import { END_POINTS } from "../constants/url";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  statusCode: number;
  message: string;
}

export const bannerApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    addBanner: builder.mutation<CommonResponseType, any>({
      query: (body) => ({
        url: END_POINTS.banner,
        method: "POST",
        body,
      }),
    }),
    getBanners: builder.query<
      CommonResponseType & {
        data: {
          data: any[];
          total: number;
        };
      },
      {
        from: number;
        size: number;
        search: string;
      }
    >({
      query: ({ from, size, search }) => ({
        url:
          `${END_POINTS.banner}?from=${from}&size=${size}` +
          (search?.length ? `&search=${search}` : ""),
        method: "GET",
      }),
    }),
    getBannerDetail: builder.query<
      CommonResponseType & {
        data: any;
      },
      {
        id: string;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.banner}/${id}`,
        method: "GET",
      }),
    }),
    updateBanner: builder.mutation<
      CommonResponseType & { data: any },
      { body: any; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.banner}/${id}`,
        method: "PUT",
        body,
      }),
    }),
    deleteBanner: builder.mutation<CommonResponseType, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.banner}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useLazyGetBannersQuery,
  useAddBannerMutation,
  useUpdateBannerMutation,
  useDeleteBannerMutation,
  useLazyGetBannerDetailQuery,
} = bannerApi;
